import DrawLeaf from '@/services/five-card-hands/five-card-hand-leaf/DrawLeaf';
import DrawParent from '@/services/five-card-hands/five-card-hand-parent/DrawParent';
import FiveCardHandsCategory from '@/services/five-card-hands/categories/FiveCardHandsCategory';

export default class Draws extends FiveCardHandsCategory {
  constructor () {
    super();
    this.data = [
      new DrawParent({
        id: 'flushDraw',
        text: 'Flush draw',
        fullText: 'Flush draw',
        inlineText: 'a flush draw',
        isAHit: function (handInfo, drawInfo) {
          return drawInfo.flush && drawInfo.flush.type === 'four card';
        },
        children: [
          new DrawLeaf({
            id: 'flushDraw:nut',
            text: 'Nut',
            fullText: 'Nut flush draw',
            inlineText: 'a nut flush draw',
            isAHit: function (handInfo, drawInfo) {
              return drawInfo.flush && drawInfo.flush.type === 'four card' && drawInfo.flush.nutLevel === 'nut';
            },
          }),
          new DrawLeaf({
            id: 'flushDraw:secondNut',
            text: 'Second nut',
            fullText: 'Second nut flush draw',
            inlineText: 'a second nut flush draw',
            isAHit: function (handInfo, drawInfo) {
              return drawInfo.flush && drawInfo.flush.type === 'four card' && drawInfo.flush.nutLevel === 'second nut';
            },
          }),
          new DrawLeaf({
            id: 'flushDraw:thirdNut',
            text: 'Third nut',
            fullText: 'Third nut flush draw',
            inlineText: 'a third nut flush draw',
            isAHit: function (handInfo, drawInfo) {
              return drawInfo.flush && drawInfo.flush.type === 'four card' && drawInfo.flush.nutLevel === 'third nut';
            },
          }),
          new DrawLeaf({
            id: 'flushDraw:weak',
            text: 'Weak',
            fullText: 'Weak flush draw',
            inlineText: 'a weak flush draw',
            isAHit: function (handInfo, drawInfo) {
              return drawInfo.flush && drawInfo.flush.type === 'four card' && drawInfo.flush.nutLevel === 'weak';
            },
          }),
        ],
      }),
      new DrawLeaf({
        id: 'oesd',
        text: '<abbr title="Open ended straight draw">OESD</abbr>',
        fullText: 'OESD',
        inlineText: 'an open ended straight draw',
        isAHit: function (handInfo, drawInfo) {
          return drawInfo.straight && drawInfo.straight.type === 'open ended';
        },
      }),
      new DrawLeaf({
        id: 'doubleGutshot',
        text: 'Double gutshot',
        fullText: 'Double gutshot',
        inlineText: 'a double gutshot',
        isAHit: function (handInfo, drawInfo) {
          return drawInfo.straight && drawInfo.straight.type === 'double gutshot';
        },
      }),
      new DrawLeaf({
        id: 'gutshot',
        text: 'Gutshot',
        fullText: 'Gutshot',
        inlineText: 'a gutshot',
        isAHit: function (handInfo, drawInfo) {
          return drawInfo.straight && drawInfo.straight.type === 'gutshot';
        },
      }),
      new DrawLeaf({
        id: 'twoOvercards',
        text: 'Two overcards',
        fullText: 'Two overcards',
        inlineText: 'two overcards',
        isAHit: function (handInfo, drawInfo) {
          return drawInfo.topPair && drawInfo.topPair.type === 'two overcards';
        },
      }),
      new DrawLeaf({
        id: 'oneOvercard',
        text: 'One overcard',
        fullText: 'One overcard',
        inlineText: 'one overcard',
        isAHit: function (handInfo, drawInfo) {
          return drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
        },
      }),
      new DrawParent({
        id: 'backdoorFlushDraw',
        text: '<abbr title="Backdoor flush draw">Bckdr fl draw</abbr>',
        fullText: 'Backdoor flush draw',
        inlineText: 'a backdoor flush draw',
        isAHit: function (handInfo, drawInfo) {
          return drawInfo.flush && drawInfo.flush.type === 'backdoor';
        },
        children: [
          new DrawLeaf({
            id: 'backdoorFlushDraw:nut',
            text: 'Nut',
            fullText: 'Backdoor nut flush draw',
            inlineText: 'a backdoor nut flush draw',
            isAHit: function (handInfo, drawInfo) {
              return drawInfo.flush && drawInfo.flush.type === 'backdoor' && drawInfo.flush.nutLevel === 'nut';
            },
          }),
          new DrawLeaf({
            id: 'backdoorFlushDraw:secondNut',
            text: 'Second nut',
            fullText: 'Backdoor second nut flush draw',
            inlineText: 'a backdoor second nut flush draw',
            isAHit: function (handInfo, drawInfo) {
              return drawInfo.flush && drawInfo.flush.type === 'backdoor' && drawInfo.flush.nutLevel === 'second nut';
            },
          }),
          new DrawLeaf({
            id: 'backdoorFlushDraw:thirdNut',
            text: 'Third nut',
            fullText: 'Backdoor third nut flush draw',
            inlineText: 'a backdoor third nut flush draw',
            isAHit: function (handInfo, drawInfo) {
              return drawInfo.flush && drawInfo.flush.type === 'backdoor' && drawInfo.flush.nutLevel === 'third nut';
            },
          }),
          new DrawLeaf({
            id: 'backdoorFlushDraw:weak',
            text: 'Weak',
            fullText: 'Backdoor weak flush draw',
            inlineText: 'a backdoor weak flush draw',
            isAHit: function (handInfo, drawInfo) {
              return drawInfo.flush && drawInfo.flush.type === 'backdoor' && drawInfo.flush.nutLevel === 'weak';
            },
          }),
        ],
      }),
      new DrawLeaf({
        id: 'backdoorStraightDraw',
        text: '<abbr title="Backdoor straight draw">Bckdr str draw</abbr>',
        fullText: 'Backdoor straight draw',
        inlineText: 'a backdoor straight draw',
        isAHit: function (handInfo, drawInfo) {
          return drawInfo.straight && drawInfo.straight.type === 'backdoor';
        },
      }),
    ];
    super.setBreadcrumbText();
  };
};



// WEBPACK FOOTER //
// ./src/services/five-card-hands/categories/Draws.js